// Design Lab only — visual tokens for the 3 candidate directions.
// Nothing here is imported by the live app.

export const MOCK = {
  teacher:
    "https://images.pexels.com/photos/6326370/pexels-photo-6326370.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  students: [
    "https://images.unsplash.com/photo-1516534775068-ba3e7458af70?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
    "https://images.unsplash.com/photo-1513258496099-48168024aec0?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
    "https://images.unsplash.com/photo-1604933762021-54a5858c9832?crop=entropy&cs=srgb&fm=jpg&w=400&q=70",
  ],
  chat: [
    { name: "Aarav Kumar", msg: "Sir, please repeat the last formula 🙏", me: false },
    { name: "Priya S.", msg: "Audio is crystal clear today", me: false },
    { name: "You (Host)", msg: "Notes PDF sharing in 2 minutes.", me: true },
    { name: "Rohit V.", msg: "Joined late, which page are we on?", me: false },
  ],
  questions: [
    { q: "Will this topic come in the July paper?", by: "Sneha", votes: 12 },
    { q: "Can you explain step 3 again?", by: "Imran", votes: 7 },
  ],
  meetings: [
    { room: "udyog-92db5b72", title: "GS Foundation — Polity Ch. 4", active: 184, total: 241, status: "LIVE" },
    { room: "udyog-e26996bc", title: "Economy Crash Course", active: 0, total: 176, status: "ENDED" },
    { room: "udyog-4f1a77c2", title: "Doubt Clearing — Batch B", active: 0, total: 92, status: "SCHEDULED" },
  ],
  stats: [
    { label: "Live now", value: "184" },
    { label: "Classes this week", value: "12" },
    { label: "Avg. watch time", value: "48m" },
    { label: "WhatsApp captured", value: "1,204" },
  ],
};

export const BANNERS = [
  {
    id: "brand",
    label: "Udyog signature",
    url: "https://static.prod-images.emergentagent.com/jobs/b7f9df05-7c8f-424c-9101-a8f7aa4aef1e/images/bbd7f928d78cc070a6443eb57d03b1d50e00d30fa69fef2bda52da07048797e6.jpeg",
  },
  {
    id: "desk",
    label: "Study desk",
    url: "https://static.prod-images.emergentagent.com/jobs/b7f9df05-7c8f-424c-9101-a8f7aa4aef1e/images/2fd92c57d05a21e4bded96c7372dc4982abf1e1ed3ddb14775d535da0ae39918.jpeg",
  },
  {
    id: "gradient",
    label: "Emerald gradient",
    url: "https://images.unsplash.com/photo-1617957718645-7680362d6312?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "waves",
    label: "Dark waves",
    url: "https://images.unsplash.com/photo-1710438399422-2fca27686bcd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "night",
    label: "Night study",
    url: "https://images.unsplash.com/photo-1690788210614-9052cffd8a14?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
];

export const DIRECTIONS = [
  {
    id: "cinematic",
    name: "Cinematic Glass",
    tagline: "Masterclass-style. Floating glass island dock, deep blurs, emerald light bleed.",
    head: "dl-head-cinematic",
    body: "dl-body-cinematic",
    page: "bg-black",
    ambient: "cinematic",
    surface: "bg-black/50 backdrop-blur-2xl border border-white/10",
    panel: "bg-black/45 backdrop-blur-2xl border border-white/10 rounded-3xl",
    radius: "rounded-3xl",
    radiusSm: "rounded-2xl",
    tile: "rounded-3xl border border-white/10 overflow-hidden",
    thumb: "rounded-2xl border border-white/10 overflow-hidden",
    dockWrap: "px-4 pb-4",
    dock:
      "rounded-full bg-black/60 backdrop-blur-2xl border border-white/10 shadow-[0_10px_40px_rgba(0,0,0,0.7)]",
    dockBtn:
      "rounded-full bg-white/5 border border-white/10 hover:bg-white/12 text-white/85",
    dockBtnOn: "rounded-full bg-emerald-500/90 border border-emerald-300/40 text-black",
    leaveBtn: "rounded-full bg-red-500/90 hover:bg-red-500 text-white",
    primary:
      "rounded-full bg-emerald-500 hover:bg-emerald-400 text-black font-semibold shadow-[0_8px_30px_-8px_rgba(16,185,129,0.8)]",
    ghost: "rounded-full border border-white/12 text-white/70 hover:bg-white/5",
    input:
      "rounded-2xl bg-white/[0.04] border border-white/10 focus:border-emerald-400/70 text-white placeholder-white/25",
    label: "text-[10px] uppercase tracking-[0.22em] text-white/40",
    tabOn: "rounded-full bg-emerald-500/15 text-emerald-300 border border-emerald-400/30",
    tabOff: "rounded-full text-white/45 border border-transparent hover:text-white/80",
    statTile: "rounded-3xl bg-white/[0.03] backdrop-blur-xl border border-white/10",
    row: "rounded-2xl bg-white/[0.02] border border-white/[0.06] hover:bg-white/[0.05]",
    muted: "text-white/45",
    text: "text-white",
  },
  {
    id: "brutalist",
    name: "Swiss Grid",
    tagline: "Editorial and technical. Sharp 1px emerald rules, flush edge-to-edge dock, mono numerals.",
    head: "dl-head-brutalist",
    body: "dl-body-brutalist",
    page: "bg-[#0A0A0A]",
    ambient: "grid",
    surface: "bg-[#141414] border border-emerald-500/25",
    panel: "bg-[#0d0d0d] border-l border-emerald-500/25",
    radius: "rounded-none",
    radiusSm: "rounded-none",
    tile: "rounded-none border border-emerald-500/25 overflow-hidden",
    thumb: "rounded-none border border-white/10 overflow-hidden",
    dockWrap: "",
    dock: "rounded-none bg-[#0d0d0d] border-t border-emerald-500/25",
    dockBtn:
      "rounded-none bg-[#141414] border border-white/10 hover:border-emerald-400/70 text-neutral-300",
    dockBtnOn: "rounded-none bg-emerald-500 border border-emerald-400 text-black",
    leaveBtn: "rounded-none bg-red-600 hover:bg-red-500 text-white uppercase tracking-[0.15em]",
    primary:
      "rounded-none bg-emerald-500 hover:bg-emerald-400 text-black uppercase tracking-[0.2em] text-[11px] font-bold",
    ghost: "rounded-none border border-emerald-500/30 text-emerald-300 hover:bg-emerald-500/10",
    input:
      "rounded-none bg-[#0d0d0d] border border-emerald-500/30 focus:border-emerald-400 text-neutral-100 placeholder-neutral-600",
    label: "text-[10px] uppercase tracking-[0.28em] text-emerald-500/70",
    tabOn: "rounded-none bg-emerald-500 text-black uppercase tracking-[0.15em]",
    tabOff:
      "rounded-none text-neutral-500 border border-transparent hover:text-emerald-300 uppercase tracking-[0.15em]",
    statTile: "rounded-none bg-[#111111] border border-white/10",
    row: "rounded-none bg-[#111111] border-b border-white/[0.08] hover:bg-[#161616]",
    muted: "text-neutral-500",
    text: "text-neutral-100",
  },
  {
    id: "neumorphic",
    name: "Soft Obsidian",
    tagline: "Low-fatigue for 3-hour classes. Chunky tactile controls, rounded clay panels, gentle glows.",
    head: "dl-head-neu",
    body: "dl-body-neu",
    page: "bg-[#0F1210]",
    ambient: "soft",
    surface: "bg-[#1A1F1C] border border-white/5 dl-neu-out",
    panel: "bg-[#161A18] border border-white/5 rounded-2xl dl-neu-out",
    radius: "rounded-2xl",
    radiusSm: "rounded-xl",
    tile: "rounded-2xl overflow-hidden dl-neu-out",
    thumb: "rounded-xl overflow-hidden dl-neu-out",
    dockWrap: "px-4 pb-4",
    dock: "rounded-2xl bg-[#1A1F1C] border border-white/5 dl-neu-out",
    dockBtn: "rounded-xl bg-[#232925] text-neutral-300 dl-neu-btn",
    dockBtnOn: "rounded-xl bg-emerald-600 text-white dl-neu-btn",
    leaveBtn: "rounded-xl bg-red-600/90 hover:bg-red-500 text-white dl-neu-btn",
    primary: "rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-semibold dl-neu-btn",
    ghost: "rounded-xl bg-[#232925] text-neutral-300 dl-neu-btn",
    input: "rounded-xl bg-[#121614] border border-black/40 dl-neu-in text-neutral-100 placeholder-neutral-600",
    label: "text-[11px] uppercase tracking-[0.16em] text-emerald-500/80",
    tabOn: "rounded-xl bg-emerald-600 text-white",
    tabOff: "rounded-xl text-neutral-400 hover:text-neutral-100",
    statTile: "rounded-2xl bg-[#1A1F1C] border border-white/5 dl-neu-out",
    row: "rounded-2xl bg-[#1A1F1C] border border-white/5 dl-neu-out",
    muted: "text-neutral-400",
    text: "text-neutral-100",
  },
];
